export enum BrowseSortType {
    PC_RELEASE_DATE = 'pcReleaseDate',
    CURRENT_PRICE = 'currentPrice',
    RELEASE_DATE = 'releaseDate',
    RELEVANCE = 'relevancy',
    TITLE = 'title',
    COMING_SOON = 'comingSoon'
}

export enum BrowseSortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}

export interface BrowseSort {
    sortDir: BrowseSortDirection;
    sortBy: BrowseSortType;
}
